import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apiService } from '../services/api';
import Logger from '../utils/logger';
import MonitoringContent from '../components/MonitoringContent';

const MonitoringPage: React.FC = () => {
  const { t } = (useTranslation as any)('monitoring');
  const { deploymentId } = useParams<{ deploymentId: string }>();
  const navigate = useNavigate();
  const [deploymentName, setDeploymentName] = useState<string>('');

  useEffect(() => {
    const fetchDeploymentDetails = async () => {
      try {
        const details = await apiService.getDeploymentDetails(deploymentId!);
        setDeploymentName(details.application_name);
      } catch (error) {
        Logger.error('Failed to load deployment details', error);
      }
    };

    if (deploymentId) {
      fetchDeploymentDetails();
    }
  }, [deploymentId]);

  return (
    <>
      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold text-text-primary">
            {t('title', { name: deploymentName })}
          </h1>
          <p className="text-text-secondary mt-2">
            {t('subtitle')}
          </p>
        </div>
        <button
          onClick={() => navigate(`/deployments/${deploymentId}/manage`)}
          className="bg-surface-3 hover:bg-surface-4 text-text-primary border border-border-1 font-bold py-2 px-4 rounded"
        >
          &larr; {t('back')}
        </button>
      </div>

      <MonitoringContent deploymentId={deploymentId!} />
    </>
  );
};

export default MonitoringPage;
